/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum NavigationHistory {
    LastHomeRoute = 'lastHomeRoute',
    LastConfigRoute = 'lastConfigRoute',
}
